// extracted by mini-css-extract-plugin
export default {"container":"main_container__3WTSY","inner":"main_inner__2L0xj","playVideo":"main_playVideo__12NEk"};